<template>
    <main-section class="main-section--sm pt-0">
        <template #tit>당신의 브랜드를 위한 <span class="primary--text">맞춤 건강식품 생산</span></template>
        <template #txt>20년 기술력으로 귀사의 제품을 만들어드립니다</template>

        <v-row justify="space-between" class="row--lg producing-steps">
            <v-col v-for="(step, index) in steps" :key="index" cols="6" lg="3" xl="auto">
                <v-card img="/images/main/producing/producing.png" flat width="240" class="mx-auto">
                    <v-responsive :aspect-ratio="280 / 320">
                        <v-responsive aspect-ratio="1" class="d-flex align-center">
                            <div class="text-center">
                                <div class="tit tit--xs primary--text line-height-1">STEP 0{{ index + 1 }}</div>
                                <div class="txt grey--text text--darken-4 font-weight-medium mt-4px mt-lg-8px">
                                    {{ step.name }}
                                </div>
                                <v-img :src="step.icon" alt="" class="mx-auto mt-8px" />
                            </div>
                        </v-responsive>
                    </v-responsive>
                </v-card>
            </v-col>
        </v-row>
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";

export default {
    components: {
        MainSection,
    },
    data() {
        return {
            steps: [
                {
                    name: "상담 및 기획",
                    icon: "/images/main/producing/producing-icon-1.svg",
                },
                {
                    name: "연구 개발",
                    icon: "/images/main/producing/producing-icon-2.svg",
                },
                {
                    name: "생산 및 품질관리",
                    icon: "/images/main/producing/producing-icon-3.svg",
                },
                {
                    name: "납품/출시",
                    icon: "/images/main/producing/producing-icon-4.svg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.producing-steps {
    .v-image {
        max-width: 34px;
    }
    @media (min-width: 576px) {
        .v-image {
            max-width: 40px;
        }
    }
    @media (min-width: 768px) {
        .v-image {
            max-width: 60px;
        }
    }
}

@media (min-width: 1024px) {
}
@media (min-width: 1400px) {
    .producing-steps {
        > [class*="col"] {
            &:not(:first-child) {
                .v-card {
                    overflow: visible;
                    .v-responsive {
                        overflow: visible;
                        &.d-flex {
                            position: relative;
                            &::before {
                                content: "";
                                position: absolute;
                                left: -55px;
                                top: 50%;
                                transform: translateY(-50%);
                                width: 22px;
                                height: 40.62px;
                                background: url(/images/main/producing/icon-arrow.svg) no-repeat center / cover;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>